import { LoadableRoute } from 'routes/utils/loadable';

export const CandidatesContainer = LoadableRoute({
  loader: () => import(/* webpackChunkName: "Candidates" */ './Candidates'),
});
